import type { GraphQLFilter } from "~/helpers/ag-grid/convertAgGridFilterToGraphQL";

const addSearchFilter = (searchTerm: string | undefined, searchFields: string[]): GraphQLFilter | undefined => {
	const trimmed = searchTerm?.trim();
	if (!trimmed) return undefined;
	return { or: searchFields.map((field) => ({ [field]: { contains: trimmed } })) };
};

export default addSearchFilter;
